<script setup lang="ts">
import LeComptoirDesPharmacies from "@/disruption-logistics/components/LeComptoirDesPharmaciesIcon.vue";
import {
    AvailabilityState
} from "@/disruption-logistics/components/product-availability-card/ProductAvailabilityRateCard.vue";
import {computed} from "vue";
import Icon from "@/core/components/icon/Icon.vue";
import BaseSpinner from "@/core/components/base/spinner/BaseSpinner.vue";

const props = defineProps<{ medidestock: any, leComptoirDesPharmacies: any }>();

const isAvailable = computed(() => {
    if (props.medidestock?.is_available === null || props.leComptoirDesPharmacies?.is_available === null) {
        return null;
    }

    return [props.medidestock, props.leComptoirDesPharmacies].some(provider => !!provider?.is_available);
});

/**
 * Get the availability label.
 */
const availabilityLabel = (provider: AvailabilityState<unknown>) => {
    if (provider.is_available) {
        return 'Disponible';
    } else if (!provider.is_available) {
        return 'Indisponible';
    }
};
</script>

<template>
  <div
    class="gap-4 text-lg bg-white shadow p-3 rounded-lg border-2"
    :class="[
      {'border-primary': isAvailable === null},
      {'border-secondary': isAvailable === true},
      {'border-red-500': isAvailable === false}
    ]">
    <div class="flex flex-row items-center justify-between gap-3">
      <p>🛒<span class="text-primary font-semibold">
        Disponible en marketplace
      </span>
      </p>
      <base-spinner
        v-if="medidestock?.loading || leComptoirDesPharmacies?.loading"
        size="small"
      />
      <icon
        v-else
        :name="isAvailable ? 'mdi-check-bold' : 'mdi-close-thick'"
        :color="isAvailable ? '#65efca' : 'red'"
        :size="25"
      />
    </div>
    <div class="flex bg-white rounded-md py-2 items-center gap-4">
      <div class="flex flex-row justify-center" style="width: 40px">
        <img
          src="@/assets/medidestock.png"
          alt="medidestock"
          style="height: 35px;"
        >
      </div>
      <div class="flex flex-col justify-center">
        <p class="text-sm leading-none">
          {{
            !medidestock ? 'Interrogation de Medidestock' : `${availabilityLabel(medidestock)} chez Medidestock`
          }}
        </p>
        <div class="text-primary">
          <a
            class="text-sm"
            target="_blank"
            href="https://medi-destock.com/"
          >
            Devenir client
          </a>
        </div>
      </div>
    </div>
    <div class="flex bg-white rounded-md py-2 items-center gap-4">
      <le-comptoir-des-pharmacies />
      <div>
        <p class="text-sm leading-none">
          {{
            !leComptoirDesPharmacies ? 'Interrogation de Le comptoir des pharmacies' : `${availabilityLabel(leComptoirDesPharmacies)} chez Le comptoir des pharmacies`
          }}
        </p>
        <div class="text-primary">
          <a
            class="text-sm"
            target="_blank"
            href="https://medi-destock.com/"
          >
            Devenir client
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>